module.exports = __webpack_public_path__ + "img/iPad_sml-df3a71d46a26c7c9a2c9364a58e235af.png";